module.exports = __webpack_public_path__ + "img/addidas_preview.fba92d1b.jpg";